import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog'// error log
import './permission' // permission control
import './mock' // simulation data

import  './common/fonts/iconfont.css'
import  './styles/reset.scss'
import * as filters from './filters' // global filters
// import VideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
import md5 from 'js-md5';
import 'moment/locale/zh-cn'
import 'moment/locale/en-au'
import 'animate.css'
import Moment from 'moment'
import vueComponent from './vue-component'
import uploader from 'vue-simple-uploader'
//兼容IE
import 'babel-polyfill'
import promise from 'es6-promise';
import flvjs from 'flvjs';
Vue.use(flvjs);

// import xgplayer from 'xgplayer'
//
// Vue.use(xgplayer)

import axios from 'axios'
import Cookies from 'js-cookie'
import './utils/flexible'
// import onlyNumber from '@/directive/el-input'; //添加此行=>自定义全局指令
// 引入video.js

import Videojs from 'video.js'

import 'video.js/dist/video-js.css'
promise.polyfill();
Vue.prototype.$video = Videojs
Vue.prototype.$md5 = md5;
// Vue.use(onlyNumber); //添加此行=>使用该全局指令
Vue.prototype.$http = axios;

Vue.prototype.$EventBus = new Vue() //事件总线

Vue.prototype.$Error_notify = function (){
  let mediaTimeStateObject = this.$store.getters.mediaTimeStateObject
  if(this.$store.getters.mediaTimeState == 3){
    const h = this.$createElement;
    this.$notify({
      title:this.$t('common.mediaTimeStateNotifyErrorTitle'),
      message:h('p', null, [
        h('div', null, this.$t('common.mediaTimeStateNotifyErrorContent')),
        h('div', null, this.$t('common.company') + mediaTimeStateObject.company
          + '，' + this.$t('common.email') + mediaTimeStateObject.email + '，' + this.$t('common.phone') + mediaTimeStateObject.phone)
      ]),
      type:'error',
      offset: 95,
      duration: 3000,
      showClose:true,
      customClass:'customClass-mediaTimeStateOne'
    });
    return false;
  }else{
    return true;
  }
}

// 前端页面监控
import {recordBehaviorsBefore,recordBehaviorsAfter} from './monitoring/performanceMonitoring'
Vue.prototype.recordBehaviorsBefore = recordBehaviorsBefore
Vue.prototype.recordBehaviorsAfter = recordBehaviorsAfter


// Vue.use(VideoPlayer)
Vue.use(Cookies)
Vue.use(vueComponent)
Vue.use(uploader)
Vue.prototype.moment = Moment
if(Cookies.get('language') == "zh"){
  Vue.prototype.moment.locale('zh-cn')
}else if(Cookies.get('language') == "en"){
  Vue.prototype.moment.locale('en-gb')
}else if(Cookies.get('language') == "ko"){
  Vue.prototype.moment.locale('ko')
}else if(Cookies.get('language') == "zh_ft"){
  Vue.prototype.moment.locale('zh-mo')
}

Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


Vue.config.productionTip = false

// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    if(Cookies.get('language') == "zh"){
      document.title = 'Q-NEX 工作台'
    }else if(Cookies.get('language') == "en"){
      document.title = 'Q-NEX Console'
    }else if(Cookies.get('language') == "ko"){
      document.title = 'Q-NEX Console'
    }else if(Cookies.get('language') == "zh_ft"){
      document.title = 'Q-NEX 工作臺'
    }else{
      document.title = 'Q-NEX Console'
    }
  }
})
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js